import { ROUTES } from '@client/routes/components/Router/routes';
import { UseUrlCreatorReturnType } from '@client/routes/hooks';
import { getCategoryUrlParams } from '@client/routes/utils/url';
import { CrumbType } from '@lib/components/Breadcrumbs';
import { NavigationItemType } from 'b2b-common/core/catalog/Catalog.types';

export function getCrumbsFromCategories(
  categories: NavigationItemType[],
  urlCreator: UseUrlCreatorReturnType,
): CrumbType[] {
  return categories.map((category) => ({
    title: category.name,
    url: `${urlCreator(ROUTES.category)}${getCategoryUrlParams(category.url)}`,
  }));
}
